import type { Dictionary } from '../../i18n/dictionary';

const pl = {
  appName: 'Admin',
  overview: 'Przegląd',
  users: 'Użytkownicy',

  overviewTitle: 'Przegląd — Admin — ITLamb',
  application: 'Aplikacja',
  userCount: 'Użytkownicy',
  appCount: 'Aplikacje',
  storage: 'Dysk',
  diskChart: 'Zajętość dysku',
  diskUsedSlice: 'Zajęte',
  diskFreeSlice: 'Wolne',
  diskOf: (total: string) => `z ${total}`,
  database: 'Baza danych',
  databaseSize: 'Rozmiar bazy',
  owner: 'Aplikacja',
  size: 'Rozmiar',
  rows: 'Wiersze',
  coreOwner: 'Platforma (core)',
  otherOwner: 'Pozostałe',

  usersTitle: 'Użytkownicy — Admin — ITLamb',
  createUser: 'Nowy użytkownik',
  login: 'Login',
  password: 'Hasło',
  confirmPassword: 'Powtórz hasło',
  apps: 'Aplikacje',
  create: 'Utwórz',
  save: 'Zapisz',
  cancel: 'Anuluj',
  editAccess: (login: string) => `Edytuj dostęp użytkownika ${login}`,
  deleteUser: (login: string) => `Usuń użytkownika ${login}`,
  confirmDelete: (login: string) =>
    `Usunąć użytkownika „${login}”? Tej operacji nie można cofnąć.`,
  noUsers: 'Brak użytkowników.',

  loadOverviewFailed: 'Nie udało się wczytać przeglądu.',
  loadUsersFailed: 'Nie udało się wczytać użytkowników.',
  createUserFailed: 'Nie udało się utworzyć użytkownika.',
  saveAccessFailed: 'Nie udało się zapisać dostępu.',
  accessSaved: 'Dostęp zapisany.',
  deleteUserFailed: 'Nie udało się usunąć użytkownika.',
};

const en: typeof pl = {
  appName: 'Admin',
  overview: 'Overview',
  users: 'Users',

  overviewTitle: 'Overview — Admin — ITLamb',
  application: 'Application',
  userCount: 'Users',
  appCount: 'Apps',
  storage: 'Storage',
  diskChart: 'Disk usage',
  diskUsedSlice: 'Used',
  diskFreeSlice: 'Free',
  diskOf: (total) => `of ${total}`,
  database: 'Database',
  databaseSize: 'Database size',
  owner: 'App',
  size: 'Size',
  rows: 'Rows',
  coreOwner: 'Platform (core)',
  otherOwner: 'Other',

  usersTitle: 'Users — Admin — ITLamb',
  createUser: 'Create user',
  login: 'Login',
  password: 'Password',
  confirmPassword: 'Confirm password',
  apps: 'Apps',
  create: 'Create',
  save: 'Save',
  cancel: 'Cancel',
  editAccess: (login) => `Edit access for ${login}`,
  deleteUser: (login) => `Delete user ${login}`,
  confirmDelete: (login) => `Delete user "${login}"? This cannot be undone.`,
  noUsers: 'No users yet.',

  loadOverviewFailed: 'Could not load the overview.',
  loadUsersFailed: 'Could not load users.',
  createUserFailed: 'Could not create the user.',
  saveAccessFailed: 'Could not save access.',
  accessSaved: 'Access saved.',
  deleteUserFailed: 'Could not delete the user.',
};

export const adminDict: Dictionary<typeof pl> = { pl, en };
